<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="center_text mb-21 certificate" v-if="this.slideForm.flag">
            <p>신청하신 서류는</p>
            <p><b>총 {{form.requestData.certificateCodeList.codeLength + 1}}건</b> 입니다.</p>
          </div>
          <div class="center_text mb-21 certificate" v-else>
            <p>신청하신 서류는</p>
            <p><b>총 {{form.requestData.certificateCodeList.codeLength}}건</b> 입니다.</p>
          </div>
          <div class="label_wrap full request">
            <div class="lw_item_wrap">
              <div class="lw_another" v-if="this.slideForm.flag">
                <div class="lw_item reqDetailNone">
                  <label class="type">
                    <div class="lw_textWrap request">
                      <div class="lw_left">
                        <p class="nameVal" v-text="getSlideBlock.name"></p>
                      </div>
                      <div class="lw_right req">
                        <p class="priceVal">{{getSlideBlock.price | plusComma}}원</p>
                      </div>
                    </div>
                  </label>
                </div>
                <div class="description red">
                  <div class="imgWrap">
                    <img src="@/assets/images/caution.svg">
                  </div>
                  <p>슬라이드/블럭은 상황에 따라 가격이 변동될 수 있습니다.</p>
                  <p>슬라이드/블럭은 발급완료를 확인 후 수령하실 수 있습니다.</p>
                  <p>발급이 완료되면 PUSH 알람이 발송됩니다.</p>
                </div>
              </div>
              <div class="lw_item_wrap width-100" v-if="this.form.requestData.certificateCodeList.codeLength > 0">
                <div class="lw_item req" v-for="c in getRequestData" :key="c.id" :class="{detailNone: c.detail === null}">
                  <label class="type">
                    <div class="lw_textWrap request">
                      <div class="lw_left">
                        <p class="nameVal">{{c.name}}</p>
                        <p class="detailVal">{{c.detail}}</p>
                      </div>
                      <div class="lw_right">
                        <p class="priceVal">{{c.price | plusComma}}원</p>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div class="explain" v-if="this.slideForm.flag && this.form.requestData.certificateCodeList.codeLength > 0">
                <h3>슬라이드/블럭 1건</h3>
                <h3>그 외 <b v-text="this.form.requestData.certificateCodeList.codeLength"></b>건</h3>
              </div>
            </div>
          </div>
          <div class="request_wrap">
            <div class="title_wrap request"
             v-if="this.requestForm.flag ||
                   this.engForm.flag ||
                   this.doctorRequestForm.flag ||
                   this.billForm.flag ||
                   this.visitForm.flag ||
                   this.detailForm.flag">
              <p class="warn">필수입력정보입니다.</p>
            </div>
            <div class="dateFormTitle" v-if="billForm.flag || visitForm.flag || detailForm.flag">
              <h2>발급기간을 설정해주세요.</h2>
            </div>
            <div class="rw_requestForm dateForm" v-if="billForm.flag">
              <h2 :class="{pb15 : form.billStartDate.value !== '' || form.billEndDate.value !== ''}">영수증/계산서</h2>
              <div class="datepicker-trigger search">
                <div class="searchListWrap">
                  <div class="inBtn pre red" :class="{black : form.billStartDate.value !== '' && form.billEndDate.value !== '', pb15 : form.billStartDate.value !== '' || form.billEndDate.value !== ''}">
                    <button type="button" class="search function" id="datepicker-input-trigger-bill">
                      기간설정
                    </button>
                  </div>
                </div>
              </div>
              <div class="dateSet" :class="{setData : form.billStartDate.value !== '' || form.billEndDate.value !== ''}">
                <p v-if="form.billStartDate.value !== '' || form.billEndDate.value !== ''">{{formatDates(form.billStartDate.value, form.billEndDate.value)}}</p>
              </div>
              <div class="inlineDatePicker">
                <AirbnbStyleDatepicker
                  :trigger-element-id="'datepicker-input-trigger-bill'"
                  v-on:closed="onClosed"
                  :mode="'range'"
                  :date-one="form.billStartDate.value"
                  :date-two="form.billEndDate.value"
                  :monthsToShow="1"
                  :inline="false"
                  :widthSet= this.width
                  :showActionButtons="true"
                  :trigger="trigger"
                  :customized-dates="[
    { cssClass: 'normal', dates: ['2020-04-20', '2020-04-21'] },
    { cssClass: 'range', dates: ['2020-04-24', '2020-03-25'] }
  ]"
                  :showShortcutsMenuTrigger="false"
                  @date-one-selected="val => {
            form.billStartDate.value = val
          }"
                  @date-two-selected="val => {
            form.billEndDate.value = val

          }"
                  @next-month="val => {
            // this.setPreviosButton(0, val)
            this.getMonthInfo (val)
          }"
                  @previous-month="val => {
           // this.setPreviosButton(1, val)
            this.getMonthInfo (val)
          }"
                />
              </div>
            </div>
            <div class="rw_requestForm dateForm" v-if="visitForm.flag">
              <h2 :class="{pb15 : form.visitStartDate.value !== '' || form.visitEndDate.value !== ''}">통원확인서/진료확인서</h2>
              <div class="datepicker-trigger search">
                <div class="searchListWrap">
                  <div class="inBtn pre red" :class="{black : form.visitStartDate.value !== '' && form.visitEndDate.value !== '', pb15 : form.visitStartDate.value !== '' || form.visitEndDate.value !== ''}">
                    <button type="button" class="search function" id="datepicker-input-trigger-visit" @click="pickerMethod()">
                      기간설정
                    </button>
                  </div>
                </div>
              </div>
              <div class="dateSet" :class="{setData : form.visitStartDate.value !== '' || form.visitEndDate.value !== ''}">
                <p v-if="form.visitStartDate.value !== '' || form.visitEndDate.value !== ''">{{formatDates(form.visitStartDate.value, form.visitEndDate.value)}}</p>
              </div>
              <div class="inlineDatePicker">
                <AirbnbStyleDatepicker
                  :trigger-element-id="'datepicker-input-trigger-visit'"
                  v-on:closed="onClosed"
                  :mode="'range'"
                  :date-one="form.visitStartDate.value"
                  :date-two="form.visitEndDate.value"
                  :monthsToShow="1"
                  :inline="false"
                  :widthSet= this.width
                  :showActionButtons="true"
                  :customized-dates="[
    { cssClass: 'normal', dates: ['2020-04-20', '2020-04-21'] },
    { cssClass: 'range', dates: ['2020-04-24', '2020-03-25'] }
  ]"
                  :showShortcutsMenuTrigger="false"
                  @date-one-selected="val => {
            form.visitStartDate.value = val
          }"
                  @date-two-selected="val => {
            form.visitEndDate.value = val

          }"
                  @next-month="val => {
            // this.setPreviosButton(0, val)
            this.getMonthInfo (val)
          }"
                  @previous-month="val => {
           // this.setPreviosButton(1, val)
            this.getMonthInfo (val)
          }"
                />
              </div>
            </div>
            <div class="rw_requestForm dateForm" v-if="detailForm.flag">
              <h2 :class="{pb15 : form.detailStartDate.value !== '' || form.detailEndDate.value !== ''}">세부내역서/상세내역서</h2>
              <div class="datepicker-trigger search">
                <div class="searchListWrap">
                  <div class="inBtn pre red" :class="{black : form.detailStartDate.value !== '' && form.detailEndDate.value !== '', pb15 : form.detailStartDate.value !== '' || form.detailEndDate.value !== ''}">
                    <button type="button" class="search function" id="datepicker-input-trigger-detail">
                      기간설정
                    </button>
                  </div>
                </div>
              </div>
              <div class="dateSet" :class="{setData : form.detailStartDate.value !== '' || form.detailEndDate.value !== ''}">
                <p v-if="form.detailStartDate.value !== '' || form.detailEndDate.value !== ''">{{formatDates(form.detailStartDate.value, form.detailEndDate.value)}}</p>
              </div>
              <div class="inlineDatePicker">
                <AirbnbStyleDatepicker
                  :trigger-element-id="'datepicker-input-trigger-detail'"
                  v-on:closed="onClosed"
                  :mode="'range'"
                  :date-one="form.detailStartDate.value"
                  :date-two="form.detailEndDate.value"
                  :monthsToShow="1"
                  :inline="false"
                  :widthSet= this.width
                  :showActionButtons="true"
                  :customized-dates="[
    { cssClass: 'normal', dates: ['2020-04-20', '2020-04-21'] },
    { cssClass: 'range', dates: ['2020-04-24', '2020-03-25'] }
  ]"
                  :showShortcutsMenuTrigger="false"
                  @date-one-selected="val => {
            form.detailStartDate.value = val
          }"
                  @date-two-selected="val => {
            form.detailEndDate.value = val

          }"
                  @next-month="val => {
            // this.setPreviosButton(0, val)
            this.getMonthInfo (val)
          }"
                  @previous-month="val => {
           // this.setPreviosButton(1, val)
            this.getMonthInfo (val)
          }"
                />
              </div>
            </div>
            <div class="rw_requestForm" v-if="requestForm.flag">
              <div class="inputHeader noLabel">
                <h2>일반진단서</h2>
              </div>
              <div class="article require" :class="{errorLaise : form.requestContent.hasError}">
                <textarea type="text" placeholder="일반진단서 발급 용도 및 기재 요청 내용을 적어주세요." v-model="form.requestContent.value" maxlength="500"
                          @keyup="blurText()" @input="blurText()" id="requestText"/>
              </div>
              <div class="inputHeader noLabel">
                <span class="warn" v-text="form.requestContent.errorTxt" v-if="form.requestContent.hasError"></span>
              </div>
            </div>
            <div class="rw_requestForm" v-if="doctorRequestForm.flag">
              <div class="inputHeader noLabel">
                <h2>의사진료소견서</h2>
              </div>
              <div class="article require" :class="{errorLaise : form.doctorRequestContent.hasError}">
                <textarea type="text" placeholder="의사진료소견서 발급 용도 및 기재 요청 내용을 적어주세요." v-model="form.doctorRequestContent.value" maxlength="500"
                          @keyup="blurDoctorText()" @input="blurDoctorText()" id="doctorRequestText"/>
              </div>
              <div class="inputHeader noLabel">
                <span class="warn" v-text="form.doctorRequestContent.errorTxt" v-if="form.doctorRequestContent.hasError"></span>
              </div>
            </div>
            <div class="rw_requestForm" v-if="engForm.flag">
              <div class="inputHeader noLabel">
                <h2>영문진단서</h2>
              </div>
              <div class="preData">
                <div class="article require half">
                  <input type="text" maxlength="21" placeholder="영문이름" v-model="form.engFirstName.value" @keyup="blurEngFirstName()" id="engFirst">
                </div>
                <div class="article require half">
                  <input type="text" maxlength="11" placeholder="성" v-model="form.engFamilyName.value" @keyup="blurEngFamilyName()" id="engFamily">
                </div>
                <div class="article require">
                  <input type="text" maxlength="100" placeholder="영문주소입력" v-model="form.engAddress.value" @keyup="blurEngAddress()" id="engAddress">
                </div>
                <div class="rw_warnWrap">
                  <span class="warn" v-if="form.engFirstName.hasError" v-text="form.engFirstName.errorTxt"></span>
                  <span class="warn" v-if="form.engFamilyName.hasError" v-text="form.engFamilyName.errorTxt"></span>
                  <span class="warn" v-if="form.engAddress.hasError" v-text="form.engAddress.errorTxt"></span>
                </div>
                <div class="rw_item">
                  <div class="rw_text">
                    <span class="warn">영문주소 검색을 활용하여 영문주소 입력 시 참고해주세요.</span>
                  </div>
                  <div class="rw_btn">
                    <a href="https://search.naver.com/search.naver?sm=top_hty&fbm=1&ie=utf8&query=%EC%98%81%EB%AC%B8%EC%A3%BC%EC%86%8C%EB%B3%80%ED%99%98" target="_blank">
                      <button type="button">영문주소검색</button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="center_text mt-55">
              <p>신청하신 서류의 장 수에 따라</p>
              <p>금액은 변동될 수 있습니다.</p>
              <h3>발급 신청을 진행하시겠습니까?</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap" :class="{half : halfFlag, visible: checkAll()}">
        <button type="button" class="callTerms cancel" @click="goMain()">취소</button>
        <button type="submit" class="callTerms" @click="submitForm()">확인</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '증명서 발급 신청하기',
        prevUrl: './certificateList'
      },
      form: {
        requestData: {
          value: [],
          certificateCodeList: {
            value: [],
            codeLength: ''
          },
          id: {
            value: ''
          },
          name: {
            value: ''
          },
          detail: {
            value: ''
          },
          price: {
            value: ''
          }
        },
        requestContent: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        doctorRequestContent: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        engFirstName: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: ''
        },
        engFamilyName: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: ''
        },
        engAddress: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: ''
        },
        billStartDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        billEndDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        visitStartDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        visitEndDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        detailStartDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        detailEndDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      halfFlag: true,
      requestForm: {
        flag: false,
        hasError: false,
        errorTxt: ''
      },
      doctorRequestForm: {
        flag: false,
        hasError: false,
        errorTxt: ''
      },
      engForm: {
        flag: false
      },
      slideForm: {
        flag: false
      },
      billForm: {
        flag: false,
        hasError: false,
        errorTxt: ''
      },
      visitForm: {
        flag: false,
        hasError: false,
        errorTxt: ''
      },
      detailForm: {
        flag: false,
        hasError: false,
        errorTxt: ''
      },
      dateFormat: 'D MMM',
      dateOne: '',
      dateTwo: '',
      width: '',
      offSetX: -50,
      trigger: false
    }
  },
  computed: {
    ...mapGetters('certificate', [
      'getCertificateList',
      'getRequestData',
      'getSlideBlock',
      'getCertificateDueDate',
      'getCertificateSlideBlock'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('certificate', [
      'SET_REQUEST'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapActions('certificate', [
      'CERTIFICATE_REQUEST'
    ]),
    pickerMethod () {
      document.body.scrollTop = 684
    },
    goMain () {
      this.SET_POPUP(true)
      this.popupSet.content = '제증명 발급 신청을 취소하시겠습니까?'
      this.popupSet.count = 'double'
      this.popupSet.nextLink = '/'
      this.popupSet.cancelBtnText = '아니오'
      this.popupSet.confirmBtnText = '예'
    },
    blurText () {
      this.form.requestContent.flag = false
      this.checkText()
    },
    checkText () {
      if (this.form.requestContent.flag) return true

      const text = this.form.requestContent.value.trim()
      if (text === '') {
        this.form.requestContent.hasError = true
        this.form.requestContent.errorTxt = '일반진단서 발급 요청사항을 입력해주세요.'
        return false
      }
      this.form.requestContent.flag = true
      this.form.requestContent.hasError = false
      this.form.requestContent.errorTxt = ''
      return true
    },
    blurDoctorText () {
      this.form.doctorRequestContent.flag = false
      this.checkDoctorText()
    },
    checkDoctorText () {
      if (this.form.doctorRequestContent.flag) return true

      const text = this.form.doctorRequestContent.value.trim()
      if (text === '') {
        this.form.doctorRequestContent.hasError = true
        this.form.doctorRequestContent.errorTxt = '의사진료소견서 발급 요청사항을 입력해주세요.'
        return false
      }
      this.form.doctorRequestContent.flag = true
      this.form.doctorRequestContent.hasError = false
      this.form.doctorRequestContent.errorTxt = ''
      return true
    },
    blurEngFirstName () {
      this.form.engFirstName.flag = false
      this.checkEngFirstName()
    },
    checkEngFirstName () {
      if (this.form.engFirstName.flag) return true

      const firstName = this.form.engFirstName.value
      if (firstName === '') {
        this.form.engFirstName.hasError = true
        this.form.engFirstName.errorTxt = '영문이름을 입력해주세요.'
        return false
      }
      const isEng = /^[a-zA-Z]*$/
      if (!isEng.test(firstName)) {
        this.form.engFirstName.hasError = true
        this.form.engFirstName.errorTxt = '영어로 입력해주세요.'
        return false
      }
      this.form.engFirstName.flag = true
      this.form.engFirstName.hasError = false
      this.form.engFirstName.errorTxt = ''
      return true
    },
    blurEngFamilyName () {
      this.form.engFamilyName.flag = false
      this.checkEngFamilyName()
    },
    checkEngFamilyName () {
      if (this.form.engFamilyName.flag) return true

      const familyName = this.form.engFamilyName.value
      if (familyName === '') {
        this.form.engFamilyName.hasError = true
        this.form.engFamilyName.errorTxt = '영문 성을 입력해주세요.'
        return false
      }
      const isEng = /^[a-zA-Z]*$/
      if (!isEng.test(familyName)) {
        this.form.engFamilyName.hasError = true
        this.form.engFamilyName.errorTxt = '영어로 입력해주세요.'
        return false
      }
      this.form.engFamilyName.flag = true
      this.form.engFamilyName.hasError = false
      this.form.engFamilyName.errorTxt = ''
      return true
    },
    blurEngAddress () {
      this.form.engAddress.flag = false
      this.checkEngAddress()
    },
    checkEngAddress () {
      if (this.form.engAddress.flag) return true

      const engAddress = this.form.engAddress.value.trim()
      if (engAddress === '') {
        this.form.engAddress.hasError = true
        this.form.engAddress.errorTxt = '영문 주소를 입력해주세요.'
        return false
      }
      const isEngNum = /^[a-zA-Z0-9 (-|,)]*$/
      if (!isEngNum.test(engAddress)) {
        this.form.engAddress.hasError = true
        this.form.engAddress.errorTxt = '영어로 입력해주세요.'
        return false
      }
      this.form.engAddress.flag = true
      this.form.engAddress.hasError = false
      this.form.engAddress.errorTxt = ''
    },
    fetchData () {
      const sessionVal = sessionStorage.getItem('certificateCodeList')
      this.form.requestData.certificateCodeList.value = sessionVal
      const toArray = this.form.requestData.certificateCodeList.value.split(',')
      console.log('toArray: ', toArray)
      this.form.requestData.certificateCodeList.value = toArray
      const newArray = toArray.slice() /* 슬라이드/블록 배열만 따로 빼기위해 배열 복사 */

      // if ((toArray.indexOf('1') !== -1) || (toArray.indexOf('4') !== -1)) {
      //   console.log('일반, 의사진료소견서', toArray)
      //   this.requestForm.flag = true
      // }
      // if (toArray.indexOf('5') !== -1) {
      //   console.log('영문진단서', toArray)
      //   this.engForm.flag = true
      // }
      if (this.getSlideBlock.id.indexOf(newArray.id)) {
        console.log('슬라이드 블럭 있음')
        const idx = newArray.indexOf(this.getSlideBlock.id)
        console.log('idx: ', idx)
        if (idx > -1) {
          newArray.splice(idx, 1)
          this.slideForm.flag = true
        }
        console.log('newArray: ', newArray)
        console.log('기존배열: ', toArray)
      }
      // if (toArray.indexOf('3') !== -1) {
      //   const slide = newArray.indexOf('3')
      //   newArray.splice(slide, 1)
      //   console.log('newArray: ', newArray)
      //   console.log('슬라이드 블럭 있으면 삭제: ', newArray)
      //   console.log('기존배열: ', toArray)
      //   this.slideForm.flag = true
      // } else {
      //   console.log('다른거')
      // }
      this.form.requestData.certificateCodeList.codeLength = newArray.length

      /* 신청한 아이디와 일치하는 리스트만 set */
      this.getCertificateList.forEach((e) => {
        if (newArray.indexOf(e.id.toString()) >= 0) {
          this.form.requestData.value.push(e)
          this.SET_REQUEST(this.form.requestData.value)
          for (let i = 0; i < this.getRequestData.length; i++) {
            if (this.getRequestData[i].name.indexOf('일반') >= 0) {
              console.log('일반진단서')
              this.requestForm.flag = true
            }
            if (this.getRequestData[i].name.indexOf('의사') >= 0) {
              console.log('의사진료소견서')
              this.doctorRequestForm.flag = true
            }
            if (this.getRequestData[i].name.indexOf('영문') >= 0) {
              console.log('영문진단서')
              this.engForm.flag = true
            }
            if (this.getRequestData[i].name.indexOf('영수증') >= 0) {
              console.log('영수증/계산서')
              this.billForm.flag = true
            }
            if (this.getRequestData[i].name.indexOf('통원') >= 0) {
              console.log('통원확인서/진료확인서')
              this.visitForm.flag = true
            }
            if (this.getRequestData[i].name.indexOf('세부') >= 0) {
              console.log('세부내역서/상세내역서')
              this.detailForm.flag = true
            }
          }
        }
        // console.log('getRequestData: ', this.getRequestData)
      })
    },
    searchPage () {
      location.href = 'https://search.naver.com/search.naver?sm=top_hty&fbm=1&ie=utf8&query=%EC%98%81%EB%AC%B8%EC%A3%BC%EC%86%8C%EB%B3%80%ED%99%98'
    },
    checkAll () {
      if (!this.engForm.flag) {
        this.form.engFirstName.flag = true
        this.form.engFamilyName.flag = true
        this.form.engAddress.flag = true
      } else {
        if (this.form.engFirstName.value === '') {
          this.form.engFirstName.flag = false
          this.form.engFirstName.hasError = true
        }
        if (this.form.engFamilyName.value === '') {
          this.form.engFamilyName.flag = false
          this.form.engFamilyName.hasError = true
        }
        if (this.form.engAddress.value === '') {
          this.form.engAddress.flag = false
          this.form.engAddress.hasError = true
        }
      }
      if (!this.requestForm.flag) {
        this.form.requestContent.flag = true
        this.requestForm.hasError = false
        this.requestForm.errorTxt = ''
      } else {
        if (this.form.requestContent.value === '') {
          this.form.requestContent.flag = false
          this.requestForm.hasError = true
          this.requestForm.errorTxt = '일반진단서 발급 용도 및 기재 요청 내용을 적어주세요.'
        }
      }
      if (!this.doctorRequestForm.flag) {
        this.form.doctorRequestContent.flag = true
        this.doctorRequestForm.hasError = false
        this.doctorRequestForm.errorTxt = ''
      } else {
        if (this.form.doctorRequestContent.value === '') {
          this.form.doctorRequestContent.flag = false
          this.doctorRequestForm.hasError = true
          this.doctorRequestForm.errorTxt = '의사진료소견서 발급 용도 및 기재 요청 내용을 적어주세요.'
        }
      }

      if (this.billForm.flag) {
        if (this.form.billStartDate.value !== '' && this.form.billEndDate.value !== '') {
          this.form.billStartDate.flag = true
          this.form.billEndDate.flag = true
          this.billForm.hasError = false
        } else {
          this.form.billStartDate.flag = false
          this.form.billEndDate.flag = false
          this.billForm.hasError = true
        }
      }

      if (this.visitForm.flag) {
        if (this.form.visitStartDate.value !== '' && this.form.visitEndDate.value !== '') {
          this.form.visitStartDate.flag = true
          this.form.visitEndDate.flag = true
          this.visitForm.hasError = false
        } else {
          this.form.visitStartDate.flag = false
          this.form.visitEndDate.flag = false
          this.visitForm.hasError = true
        }
      }

      if (this.detailForm.flag) {
        if (this.form.detailStartDate.value !== '' && this.form.detailEndDate.value !== '') {
          this.form.detailStartDate.flag = true
          this.form.detailEndDate.flag = true
          this.detailForm.hasError = false
        } else {
          this.form.detailStartDate.flag = false
          this.form.detailEndDate.flag = false
          this.detailForm.hasError = true
        }
      }

      /* 신청 내역이 없을시 필수 항목에서 제외 */

      /* 영수증/계산서 */
      if (!this.billForm.flag) {
        this.form.billStartDate.flag = true
        this.form.billEndDate.flag = true
      }
      /* 통원확인서/진료확인서 */
      if (!this.visitForm.flag) {
        this.form.visitStartDate.flag = true
        this.form.visitEndDate.flag = true
      }
      /* 세부내역서/상세내역서 */
      if (!this.detailForm.flag) {
        this.form.detailStartDate.flag = true
        this.form.detailEndDate.flag = true
      }
      return !!(this.form.requestContent.flag &&
        this.form.doctorRequestContent.flag &&
        this.form.engFirstName.flag &&
        this.form.engFamilyName.flag &&
        this.form.engAddress.flag &&
        this.form.billStartDate.flag &&
        this.form.billEndDate.flag &&
        this.form.visitStartDate.flag &&
        this.form.visitEndDate.flag &&
        this.form.detailStartDate.flag &&
        this.form.detailEndDate.flag)
    },
    submitForm () {
      if (this.checkAll()) {
        this.formAction()
      } else {
        console.log('checkAll false')

        if (this.billForm.hasError) {
          this.SET_POPUP(true)
          this.popupSet.content = '영수증/계산서 발급 기간을 설정해주세요.'
          this.popupSet.count = 'single'
          this.popupSet.closeType = 'close'
        }

        if (this.visitForm.hasError) {
          this.SET_POPUP(true)
          this.popupSet.content = '통원확인서/진료확인서 발급 기간을 설정해주세요.'
          this.popupSet.count = 'single'
          this.popupSet.closeType = 'close'
        }

        if (this.detailForm.hasError) {
          this.SET_POPUP(true)
          this.popupSet.content = '세부내역서/상세내역서 발급 기간을 설정해주세요.'
          this.popupSet.count = 'single'
          this.popupSet.closeType = 'close'
        }

        if (!this.form.requestContent.flag) {
          const text = this.form.requestContent.value.trim()
          if (text === '') {
            this.SET_POPUP(true)
            this.form.requestContent.hasError = true
            this.form.requestContent.errorTxt = '일반진단서 발급 요청사항을 입력해주세요.'
            this.popupSet.content = '일반진단서 발급 요청사항을 입력해주세요.'
            this.popupSet.count = 'single'
            this.popupSet.closeType = 'close'
            setTimeout(() => {
              document.querySelector('#requestText').focus()
            }, 1000)
            return false
          }
        }
        if (!this.form.doctorRequestContent.flag) {
          const text = this.form.doctorRequestContent.value.trim()
          if (text === '') {
            this.SET_POPUP(true)
            this.form.doctorRequestContent.hasError = true
            this.form.doctorRequestContent.errorTxt = '의사진료소견서 발급 요청사항을 입력해주세요.'
            this.popupSet.content = '의사진료소견서 발급 요청사항을 입력해주세요.'
            this.popupSet.count = 'single'
            this.popupSet.closeType = 'close'
            setTimeout(() => {
              document.querySelector('#doctorRequestText').focus()
            }, 1000)
            return false
          }
        }
        if (this.engForm.flag) {
          if (!this.form.engFirstName.flag) {
            const firstName = this.form.engFirstName.value
            if (firstName === '') {
              this.form.engFirstName.hasError = true
              this.form.engFirstName.errorTxt = '영문이름을 입력해주세요.'
              this.SET_POPUP(true)
              this.popupSet.content = '영문이름을 입력해주세요.'
              this.popupSet.count = 'single'
              this.popupSet.closeType = 'close'
              setTimeout(() => {
                document.querySelector('#engFirst').focus()
              }, 1000)
              return false
            }
          }
          if (!this.form.engFamilyName.flag) {
            const engFamilyName = this.form.engFamilyName.value
            if (engFamilyName === '') {
              this.form.engFamilyName.hasError = true
              this.form.engFamilyName.errorTxt = '영문 성을 입력해주세요.'
              this.SET_POPUP(true)
              this.popupSet.content = '영문 성을 입력해주세요.'
              this.popupSet.count = 'single'
              this.popupSet.closeType = 'close'
              setTimeout(() => {
                document.querySelector('#engFamily').focus()
              }, 1000)
              return false
            }
          }
          if (!this.form.engAddress.flag) {
            const engAddress = this.form.engAddress.value
            if (engAddress === '') {
              this.form.engAddress.hasError = true
              this.form.engAddress.errorTxt = '영문 주소를 입력해주세요.'
              this.SET_POPUP(true)
              this.popupSet.content = '영문 주소를 입력해주세요.'
              this.popupSet.count = 'single'
              this.popupSet.closeType = 'close'
              setTimeout(() => {
                document.querySelector('#engAddress').focus()
              }, 1000)
              return false
            }
          }
        }
      }
    },
    async formAction () {
      try {
        const requestData = {
          certificateCodeList: this.form.requestData.certificateCodeList.value,
          requestContent: this.form.requestContent.value.trim(),
          doctorRequestContent: this.form.doctorRequestContent.value.trim(),
          engFirstName: this.form.engFirstName.value,
          engFamilyName: this.form.engFamilyName.value,
          engAddress: this.form.engAddress.value.trim(),
          billStartDate: this.form.billStartDate.value,
          billEndDate: this.form.billEndDate.value,
          visitStartDate: this.form.visitStartDate.value,
          visitEndDate: this.form.visitEndDate.value,
          detailStartDate: this.form.detailStartDate.value,
          detailEndDate: this.form.detailEndDate.value
        }
        console.log('codeList: ', this.form.requestData.certificateCodeList.value)
        await this.CERTIFICATE_REQUEST(requestData)
          .then(() => {
            this.SET_REFERRER(window.location.href)
            const dueDate = this.getCertificateDueDate
            const slideBlock = this.getCertificateSlideBlock
            if (this.engForm.flag) {
              this.popupSet.topImg = true
              this.popupSet.content = '<p class="red">신청이 완료되었습니다.</p>' +
                '<p>업무일 기준 3일 후 발급이 완료됩니다.</p>' +
                `<p>(예정 완료일: <b>${dueDate}</b>)</p>`
              this.popupSet.count = 'another'
              this.popupSet.closeType = 'action'
              this.popupSet.closeLink = './certificateRequestDone'
              this.popupSet.nextLink = './certificateRequestDone'
              this.SET_POPUP(true)
            } else if (!this.engForm.flag &&
              !this.requestForm.flag &&
              !this.doctorRequestForm.flag &&
              !this.billForm.flag &&
              !this.visitForm.flag &&
              !this.detailForm.flag &&
              this.slideForm.flag) {
              this.popupSet.topImg = true
              this.popupSet.content = '<p class="red">신청이 완료되었습니다.</p>' +
                '<p>슬라이드/블럭은 발급완료를 확인 후 </p>' +
                '<p>수령하실 수 있습니다.</p>' +
                '<p>발급이 완료되면 </p>' +
                '<p>PUSH 알람이 발송됩니다.</p>'
              this.popupSet.count = 'another'
              this.popupSet.closeType = 'action'
              this.popupSet.closeLink = './certificateRequestDone'
              this.popupSet.nextLink = './certificateRequestDone'
              this.SET_POPUP(true)
            } else if (slideBlock && this.slideForm.flag) {
              this.popupSet.topImg = true
              this.popupSet.content = '<p class="red">신청이 완료되었습니다.</p>' +
                '<p>슬라이드/블럭은 발급완료를 확인 후 </p>' +
                '<p>수령하실 수 있습니다.</p>' +
                '<p>발급이 완료되면 </p>' +
                '<p>PUSH 알람이 발송됩니다.</p>'
              this.popupSet.count = 'another'
              this.popupSet.closeType = 'action'
              this.popupSet.closeLink = './certificateRequestDone'
              this.popupSet.nextLink = './certificateRequestDone'
              this.SET_POPUP(true)
            } else {
              this.popupSet.topImg = true
              this.popupSet.content = '<p class="red">신청이 완료되었습니다.</p>' +
                '<p>업무일 기준 2일 후 발급이 완료됩니다.</p>' +
                `<p>(예정 완료일: <b>${dueDate}</b>)</p>`
              this.popupSet.count = 'another'
              this.popupSet.closeType = 'action'
              this.popupSet.closeLink = './certificateRequestDone'
              this.popupSet.nextLink = './certificateRequestDone'
              this.SET_POPUP(true)
            }
          })
      } catch (error) {
        console.log('error :', error);
        console.log('제증명 발급 신청 API에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          if (error.data.response.message === 'RequestContent is not present') {
            this.popupSet.content = '요청사항을 입력해주세요.'
          } else {
            this.popupSet.content = errorParser.parse(error)
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.initForm()
      }
    },
    initForm () {
      this.engForm = false
      this.requestForm.flag = false
      // this.slideForm.flag = false
    },
    onClosed: function () {
      const datesStr = this.formatDates(this.form.billStartDate.value, this.form.billEndDate.value)
      console.log('Dates Selected: ' + datesStr)
      this.trigger = false
    },
    formatDates (dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = this.$moment(dateOne).format('YYYY-MM-DD')
      }
      if (dateTwo) {
        formattedDates += ' ~ ' + this.$moment(dateTwo).format('YYYY-MM-DD')
      }
      return formattedDates
    },
    date_to_str (format) {
      const year = format.getFullYear()
      console.log('year', year)
      let month = format.getMonth() + 1
      if (month < 10) month = '0' + month
      console.log('month', month)
      let date = format.getDate()
      if (date < 10) date = '0' + date
      console.log('date', date)
      return year + '-' + month + '-' + date
    },
    getMonthInfo (val) {
      const currentMonth = Number(val[0].slice(5, 7))
      let nextMonth
      let previousMonth
      this.currentMonth = currentMonth
      if (currentMonth === 12) {
        nextMonth = 1
        previousMonth = currentMonth - 1
      } else if (currentMonth === 1) {
        previousMonth = 12
        nextMonth = currentMonth + 1
      } else {
        nextMonth = currentMonth + 1
        previousMonth = currentMonth - 1
      }
      this.nextMonth = nextMonth
      this.previousMonth = previousMonth
    }
  },
  created () {
    this.width = window.innerWidth - 40
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('certificateList') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    this.fetchData()
  },
  filters: {
    plusComma (val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
  .btnWrap.half {
    z-index:101;
  }
</style>
